import React from 'react';
import { MailIcon, ClockIcon } from 'lucide-react';
export const ContactSection = () => {
  return <section id="contact" className="py-16 bg-white" data-id="element-34" data-mp="2z8tghwzufagy">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35" data-mp="2zampvk1uc8sn">
        <div className="lg:text-center" data-id="element-36" data-mp="2kkymmda3n02a">
          <h2 className="text-base text-[#D4AF37] font-semibold tracking-wide uppercase" data-id="element-37" data-mp="2khsyp1d7i485">
            Get In Touch
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-800 sm:text-4xl" data-id="element-38" data-mp="3d7t73a6x1zfr">
            Contact Us
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-600 lg:mx-auto" data-id="element-39" data-mp="3i6mk71iajofe">
            We're currently managing investments for family and close friends.
            If you're interested in learning more about our future plans, please
            reach out.
          </p>
        </div>

        <div className="mt-16 max-w-3xl mx-auto" data-id="element-40" data-mp="1sroilewhc3cq">
          <div className="bg-white py-10 px-6 shadow-lg rounded-lg" data-id="element-41" data-mp="1wu2vzjhdqawm">
            <div className="text-center mb-10" data-id="element-42" data-mp="1wrylgioz6dnd">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#D4AF37] text-white mb-4" data-id="element-43" data-mp="7ld2ulk3sa40">
                <MailIcon size={32} data-id="element-44" data-mp="2od6j2d22lq3" />
              </div>
              <h3 className="text-2xl font-bold text-slate-800 mb-4" data-id="element-45" data-mp="gml2b6ycvgzo">
                Email Us
              </h3>
              <p className="text-slate-600 mb-6" data-id="element-46" data-mp="ckpy9up1ipi7">
                We're in the process of establishing our presence in the Indian
                market. Our office and contact details will be available
                shortly.
              </p>
              <a href="mailto:aurumgrovecapital@gmail.com" className="inline-flex items-center text-xl font-medium text-[#D4AF37] hover:text-[#C9A227] transition-colors" data-id="element-47" data-mp="llnx7ykmg6tx">
                <MailIcon size={20} className="mr-2" data-id="element-48" data-mp="ve3f6vvx4vet" />
                aurumgrovecapital@gmail.com
              </a>
            </div>

            <div className="border-t border-slate-200 pt-8" data-id="element-49" data-mp="14d6wbubiz0qo">
              <div className="flex items-start" data-id="element-50" data-mp="14akri2g0qzc5">
                <div className="flex-shrink-0" data-id="element-51" data-mp="202agwwg15kz">
                  <ClockIcon size={24} className="text-[#D4AF37]" data-id="element-52" data-mp="1x6ehe45oqz6" />
                </div>
                <div className="ml-4" data-id="element-53" data-mp="6vztjaz3cq1g">
                  <h4 className="text-lg font-medium text-slate-800 mb-2" data-id="element-54" data-mp="az5uq47cjr12">
                    Office Hours
                  </h4>
                  <div className="space-y-1 text-base text-slate-600" data-id="element-55" data-mp="fr7cu6r74bz0">
                    <p data-id="element-56" data-mp="kqa9p3x0vbvw">Monday - Friday: 9:00 AM - 5:00 PM</p>
                    <p data-id="element-57" data-mp="krv3usffcst8">Saturday - Sunday: Closed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};